module.exports = __webpack_public_path__ + "static/media/newcalendar.8e706b2d.svg";